import './index.css'
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from 'react-router-dom'
import { App } from "./App";

const container = document.getElementById("root");
if (!container) throw new Error('Root element not found');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);